
<script context="module">

import { 
  VmPipControl,
  VmControl,
  VmIcon,
  VmTooltip 
} from '@vime/core';

import { define } from '../lib';
  

define('vm-pip-control', VmPipControl);
define('vm-control', VmControl);
define('vm-icon', VmIcon);
define('vm-tooltip', VmTooltip);
  
</script>

<script>
import { createEventDispatcher, onMount } from 'svelte';
import { setProp } from '../lib';

let __ref;
let __mounted = false;

const dispatch = createEventDispatcher();

let className = '';

export let style = '';
export { className as class };

export let enterIcon = 'pip-enter';
export let exitIcon = 'pip-exit';
export let icons = undefined;
export let tooltipPosition = 'top';
export let tooltipDirection = undefined;
export let hideTooltip = false;
export let keys = 'p';
export let isPiPActive = false;
export let i18n = {};
export let playbackReady = false;

export const ref = () => __ref;
export const getWebComponent = () => __ref;

onMount(() => {
  

  __mounted = true;
});

$: if (__mounted) setProp(__ref, 'i18n', i18n);

const onEvent = (e) => {
  e.stopPropagation();
  dispatch(e.type, e.detail);
};
</script>

<vm-pip-control
  class={className}
  style={style}
  enter-icon={enterIcon}
  exit-icon={exitIcon}
  icons={icons}
  tooltip-position={tooltipPosition}
  tooltip-direction={tooltipDirection}
  hide-tooltip={hideTooltip}
  keys={keys}
  is-pi-p-active={isPiPActive}
  playback-ready={playbackReady}
  
  bind:this={__ref}
>
  <slot></slot>
</vm-pip-control>
  